interface Args {
  value: number
  isExport?: boolean
  isCurrency?: boolean
}

export function formatNumber(args: Args) {
  const {value, isExport, isCurrency} = args
  const locale = !isExport ? 'id-ID' : 'en-US'
  const symbol = !isExport ? 'Rp ' : 'USD '
  return `${isCurrency ? symbol : ''}${new Intl.NumberFormat(locale).format(value as number)}`
}
